import iconv from 'iconv-lite';

export default class Utils {
  static formatFloat(floatNumber) {
    return +(floatNumber).toFixed(2);
  }

  static formatFloatOne(floatNumber) {
    return +(floatNumber).toFixed(1);
  }

  /**
     * algorithm to identify outlier
     *
     * @see https://stackoverflow.com/questions/20811131/javascript-remove-outlier-from-an-array
     */
  static getDisplayRange(data) {
    // Copy the values, rather than operating on references to existing values
    const values = data.concat();

    // Then sort
    values.sort((a, b) => a - b);

    /* Then find a generous IQR. This is generous because if (values.length / 4)
     * is not an int, then really you should average the two elements on either
     * side to find q1.
     */
    const q1 = values[Math.floor((values.length / 4))];
    // Likewise for q3.
    const q3 = values[Math.ceil((values.length * (3 / 4)))];
    const iqr = q3 - q1;

    // Then find min and max values
    const maxValue = q3 + iqr * 2;
    const minValue = q1 - iqr * 2;

    return { maxValue, minValue };

    // // Then filter anything beyond or beneath these values.
    // const filteredValues = values.filter((x) => (x <= maxValue) && (x >= minValue));

    // // Then return
    // return filteredValues;
  }

  static exportCsv(filename, csvContent) {
    const encodedCsvContent = iconv.encode(csvContent, 'BIG5');

    const blob = new Blob([encodedCsvContent], { type: 'text/csv;charset=big5;' });
    Utils.download(blob, filename);
  }

  static download(blob, filename = 'download') {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }
}
